import { Progress, Tooltip } from 'antd';
import { useState } from 'react';

import { AiGradeModal } from '@app/components/LeadCard/ui/MessageHistory/components/AiGrade/components';
import { getGradeColor } from '@app/components/LeadCard/ui/MessageHistory/components/AiGrade/lib';

import type { FC } from 'react';

import '../styles/AiGrade.scss';

// Соразмерно иконке телефона рядом (.LeadCallMessage__icon-wrap, 22px).
const BADGE_SIZE = 22;

interface AiGradeProps {
  grade: number | null;
  aiRecommendations: string | null;
  // Что именно оценил ИИ: запись звонка или голосовое сообщение. Влияет только
  // на текст подсказки и заголовок окна.
  subject?: string;
}

export const AiGrade: FC<AiGradeProps> = ({
  grade,
  aiRecommendations,
  subject = 'звонка',
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (grade === null) return null;

  return (
    <>
      <Tooltip title={`Просмотреть оценку ${subject}`}>
        <button
          type="button"
          className="AiGrade__badge"
          onClick={() => setIsModalOpen(true)}
        >
          <Progress
            type="circle"
            percent={grade}
            size={BADGE_SIZE}
            strokeWidth={14}
            strokeColor={getGradeColor(grade)}
            trailColor="rgba(0, 0, 0, 0.08)"
            format={() => grade}
          />
        </button>
      </Tooltip>
      <AiGradeModal
        grade={grade}
        aiRecommendations={aiRecommendations}
        subject={subject}
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};
